export default "__VITE_ASSET__De3i0ATM__"